import type { FunctionComponent, Ref } from 'react';

import { type Theme, useTheme } from '@dr.pogodin/react-utils';

import IconPlay from 'assets/images/icon-play-24px.svg';

import defaultTheme from './default.scss';

type PropsT = {
  imageUrl: string;
  noPlayIcon?: boolean;
  ref?: Ref<HTMLDivElement>;
  removed?: boolean;
  theme?: Theme<'container' | 'icon' | 'removedMessage'>;
};

const VideoThumbnail: FunctionComponent<PropsT> = ({
  imageUrl,
  noPlayIcon,
  ref,
  removed,
  theme,
}) => {
  const composed = useTheme('VideoThumbnail', defaultTheme, theme);

  return (
    <div
      className={composed.container}
      ref={ref}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      {noPlayIcon || removed
        ? null
        : <IconPlay className={composed.icon} />}
      {removed
        ? <div className={composed.removedMessage}>Removed</div>
        : null}
    </div>
  );
};

export default VideoThumbnail;
